export const processData = [
  { name: { fi: 'Yliaika' }, id: 1, type: 'N1' },
  { name: { fi: 'Aliaika' }, id: 2, type: 'N1' },
  { name: { fi: 'Väliaika' }, id: 3, type: 'N1' }
];
